export default "__VITE_ASSET__d0e78fa4__"